import { render, staticRenderFns } from "./JsonBuilderBlock.vue?vue&type=template&id=32d3315f"
import script from "./JsonBuilderBlock.vue?vue&type=script&lang=js"
export * from "./JsonBuilderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports